import { useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Onda 5 — Logout automático por inatividade para super_admin / developer.
 * Usuários comuns mantêm a sessão padrão do Supabase.
 *
 * @param role role atual do usuário (string ou null)
 * @param timeoutMs tempo de inatividade em ms antes de fazer logout (default 4h)
 */
export function usePrivilegedIdleTimeout(
  role: string | null | undefined,
  timeoutMs: number = 4 * 60 * 60 * 1000
) {
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (role !== "super_admin" && role !== "developer") return;

    const reset = () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(async () => {
        try {
          await supabase.auth.signOut();
          toast.warning("Sessão encerrada por inatividade", {
            description: "Por segurança, sua sessão privilegiada expirou após 4h sem atividade.",
            duration: 8000,
          });
          window.location.href = "/";
        } catch {
          window.location.href = "/";
        }
      }, timeoutMs);
    };

    const events = ["mousedown", "keydown", "touchstart", "scroll", "click"] as const;
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [role, timeoutMs]);
}
